import React__default from 'react';
import { Alert } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { DateUtils } from '@grandvisionhq/utils';
import { useAppointmentSummarySlotsContext } from '../../../../slots/AppointmentSummarySlotsContext.js';

const AppointmentsList = ({ appointments  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const { Slots: { summary: AppointmentSummary  } ,  } = useAppointmentSummarySlotsContext();
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, appointments.some((appt)=>appt.isReservation
    ) && /*#__PURE__*/ React__default.createElement(Alert, {
        type: "info",
        icon: "info",
        title: getLabel('appointments.reservation.infoAlert.title'),
        message: getFormattedLabel('appointments.reservation.infoAlert.message', {
            parseHTML: true
        })
    }), appointments.map((appointment)=>{
        // Check if date is not in the past, otherwise it's not an upcoming appointment
        return !DateUtils.isDateBefore(appointment.startTime, new Date()) ? AppointmentSummary ? /*#__PURE__*/ React__default.createElement(AppointmentSummary, {
            className: "appointment-summary",
            appointment: appointment,
            key: appointment.id
        }) : null : null;
    }));
};
var AppointmentsList$1 = AppointmentsList;

export { AppointmentsList$1 as default };
//# sourceMappingURL=AppointmentsList.js.map
